import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

type Props = {
  approved_at: null | string;
};

export const DocIsDraftBadge = ({approved_at}: Props) => {
  if (approved_at != null) {
    return null;
  }

  return (
    <LazyTooltip tooltip={gt('Document not approved yet')}>
      <span className="ml-1 badge badge-warning">
        <i className="fa fa-exclamation-triangle" /> {gt('Draft only')}
      </span>
    </LazyTooltip>
  );
};
